import { DataTable } from "@circle-react-uikit/DataTableV2";
import { usePreviewSnippetDrawer } from "./PreviewSnippetDrawer";

export const SnippetsList = ({ columns, snippetsQuery, onChangePage }: any) => {
  const previewSnippetDrawer = usePreviewSnippetDrawer();

  return (
    <DataTable
      columns={columns}
      data={snippetsQuery?.data?.records ?? []}
      isLoading={snippetsQuery?.isLoading}
      initialPage={snippetsQuery?.data?.page}
      pageSize={snippetsQuery?.data?.per_page}
      totalRecordsCount={snippetsQuery?.data?.count}
      onChangePage={onChangePage}
      onClickRow={({ original }) => {
        void previewSnippetDrawer.show({ snippetId: original.id });
      }}
    >
      <DataTable.Table>
        <DataTable.Header />
        <DataTable.Loader />
        <DataTable.Body />
      </DataTable.Table>
      <DataTable.Pagination align="left" direction="reverse" />
    </DataTable>
  );
};
